<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "Repayment"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/Repayment.vue